// @ts-nocheck
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useHotelPartnerId } from './useHotelPartnerId';
import { NOT_A_TEAM } from '../roomBlockUtils';

export function useRoomBlocks(eventIds: string[]) {
  const { data: partnerId } = useHotelPartnerId();
  return useQuery({
    queryKey: ['hotel-room-blocks', eventIds], enabled: eventIds.length > 0 && !!partnerId,
    queryFn: async () => {
      const rows = [];
      for (let offset = 0; ; offset += 1000) {
        const { data, error } = await (supabase as any).from('hotel_room_blocks').select('*')
          .in('event_id', eventIds).order('id').range(offset, offset + 999);
        if (error) throw error;
        rows.push(...(data || []));
        if ((data || []).length < 1000) break;
      }
      return rows;
    },
  });
}

export function invalidateRoomBlockQueries(qc: ReturnType<typeof useQueryClient>) {
  return Promise.all(['hotel-room-blocks', 'hotel-team-list', 'hotel-event-header', 'hotels-full',
    'hotel-dash-compliance', 'report-compliance', 'report-attrition'].map(key => qc.invalidateQueries({ queryKey: [key] })));
}

export function useUpdateRoomBlock(eventId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, registrationId, notTeam }: { id: string; registrationId?: string; notTeam?: boolean }) => {
      if (!eventId) throw new Error('Select an event first');
      const updates = notTeam ? { notes: NOT_A_TEAM } : { registration_id: registrationId, match_method: 'manual' };
      if (!notTeam && !registrationId) throw new Error('Select a team first');
      const { data, error } = await (supabase as any).from('hotel_room_blocks').update(updates)
        .eq('id', id).eq('event_id', eventId).select('id').single();
      if (error) throw error;
      if (!data) throw new Error('Room block was not updated');
    },
    onSuccess: () => invalidateRoomBlockQueries(qc),
  });
}